import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { ScrollSection } from '../components/ScrollSection';

function SupportTGH() {
  // Support images for carousel
  const supportImages = [
    {
      image: '/img/carousel/abd1.JPG',
      alt: 'Tema General Hospital Building'
    },
    {
      image: '/img/carousel/abd2.JPG',
      alt: 'Hospital Administration'
    },
    {
      image: '/img/carousel/abd3.JPG',
      alt: 'Patient Recovery'
    },
    {
      image: '/img/carousel/abd4.jpg',
      alt: 'Outpatient Department'
    }
  ];

  return (
    <>
      {/* Page Header - Tema General Style */}
      <div
        className="container-fluid"
        style={{
          background: 'linear-gradient(rgba(var(--tgh-blue-rgb), 0.9), rgba(var(--tgh-blue-rgb), 0.9)), url(/img/hospital-building.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '4rem 0 3rem',
        }}
      >
        <div className="container">
          <div className="text-center">
            <h1 className="text-white mb-0" style={{ fontSize: '2.5rem', fontWeight: '600', fontFamily: "'Lora', 'Georgia', serif" }}>
              Support Tema General Hospital
            </h1>
            <p className="text-white mt-3 mb-0" style={{ fontSize: '1.1rem', opacity: 0.9 }}>
              Join us in strengthening quality healthcare for our community
            </p>
            <nav aria-label="breadcrumb" className="mt-3 d-flex justify-content-center">
              <ol className="breadcrumb mb-0" style={{ backgroundColor: 'transparent', padding: 0 }}>
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none' }}>
                    Home
                  </Link>
                </li>
                <li className="breadcrumb-item active text-white" aria-current="page" style={{ color: 'var(--tgh-on-page-header)' }}>
                  Support Tema General Hospital
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      {/* Main Content - Tema General Style */}
      <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container" style={{ maxWidth: '1200px' }}>
          {/* Introduction Section with Image Carousel - Side by Side Layout */}
          <div style={{ marginBottom: '3rem' }}>
            <div className="tgh-news-article support-tgh-intro-section">
              <div className="row g-0 g-lg-4 align-items-lg-start">
                {/* Text Content - Left Column */}
                <div className="col-lg-5">
                  <div className="support-tgh-text-content">
                    <h2 style={{ fontSize: '2rem', fontWeight: '600', color: '#1a1a1a', marginBottom: '1rem' }}>
                      Join Us in Strengthening Quality Healthcare for Our Community
                    </h2>
                    <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#333', marginBottom: '1.5rem', textAlign: 'justify' }}>
                      Tema General Hospital continues to serve thousands of patients each month - providing essential
                      medical care, emergency services, maternal health, surgery, and more. Your support helps to:
                    </p>
                    <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#333', marginBottom: '1.5rem', textAlign: 'justify' }}>
                      We are committed to delivering exceptional healthcare services to our community. Through your generous
                      support, we can continue to improve our facilities, enhance patient care, and expand our services to
                      reach more people in need. Every contribution makes a significant impact on the lives of our patients
                      and their families.
                    </p>
                    <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#333', marginBottom: 0, textAlign: 'justify' }}>
                      Your partnership with Tema General Hospital enables us to maintain the highest standards of medical
                      excellence while ensuring that quality healthcare remains accessible to all members of our community.
                    </p>
                  </div>
                </div>
                
                {/* Image Carousel - Right Column */}
                <div className="col-lg-7 min-w-0">
                  <div className="support-tgh-image-wrapper">
                    <Swiper
                      className="support-tgh-swiper"
                      modules={[Autoplay, Pagination, Navigation]}
                      slidesPerView={1}
                      loop
                      speed={500}
                      autoplay={{
                        delay: 4000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                      }}
                      pagination={{ clickable: true }}
                      navigation
                      grabCursor>
                      {supportImages.map((item, index) => (
                        <SwiperSlide key={item.image + index}>
                          <div className="support-carousel-image-container">
                            <img
                              src={item.image}
                              alt={item.alt}
                              className="support-carousel-image"
                              loading="eager"
                              decoding="async"
                              onError={(e) => {
                                e.target.src = '/img/Gallery/opd1.jpg';
                              }}
                            />
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Benefits and Ways to Help Section */}
          <ScrollSection>
            <div className="row g-4 mb-5">
              {/* Benefits of Support */}
              <div className="col-lg-6">
                <div className="tgh-news-card h-100">
                  <div className="card-body p-4">
                    <h3 className="mb-4" style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1a1a1a', fontFamily: "'Lora', 'Georgia', serif" }}>
                      Benefits of Your Support
                    </h3>
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                      <li className="mb-3" style={{ fontSize: '1rem', lineHeight: '1.7', color: '#333', display: 'flex', alignItems: 'flex-start' }}>
                        <i className="bi bi-check-circle-fill me-3" style={{ color: 'var(--tgh-blue-light)', fontSize: '1.2rem', marginTop: '2px', flexShrink: 0 }}></i>
                        <span>Improve the quality of client care and safety</span>
                      </li>
                      <li className="mb-3" style={{ fontSize: '1rem', lineHeight: '1.7', color: '#333', display: 'flex', alignItems: 'flex-start' }}>
                        <i className="bi bi-check-circle-fill me-3" style={{ color: 'var(--tgh-blue-light)', fontSize: '1.2rem', marginTop: '2px', flexShrink: 0 }}></i>
                        <span>Have an efficient and effective work environment and harmony</span>
                      </li>
                      <li className="mb-3" style={{ fontSize: '1rem', lineHeight: '1.7', color: '#333', display: 'flex', alignItems: 'flex-start' }}>
                        <i className="bi bi-check-circle-fill me-3" style={{ color: 'var(--tgh-blue-light)', fontSize: '1.2rem', marginTop: '2px', flexShrink: 0 }}></i>
                        <span>Improve on existing infrastructure and amenities</span>
                      </li>
                      <li className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.7', color: '#333', display: 'flex', alignItems: 'flex-start' }}>
                        <i className="bi bi-check-circle-fill me-3" style={{ color: 'var(--tgh-blue-light)', fontSize: '1.2rem', marginTop: '2px', flexShrink: 0 }}></i>
                        <span>Enhance staff work experience</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Ways to Help */}
              <div className="col-lg-6">
                <div className="tgh-news-card h-100">
                  <div className="card-body p-4">
                    <h3 className="mb-4" style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1a1a1a', fontFamily: "'Lora', 'Georgia', serif" }}>
                      How You Can Help Save Lives
                    </h3>
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                      <li className="mb-3" style={{ fontSize: '1rem', lineHeight: '1.7', color: '#333', display: 'flex', alignItems: 'flex-start' }}>
                        <i className="bi bi-heart-fill me-3" style={{ color: 'var(--tgh-blue-light)', fontSize: '1.2rem', marginTop: '2px', flexShrink: 0 }}></i>
                        <span>Donate Medical Supplies</span>
                      </li>
                      <li className="mb-3" style={{ fontSize: '1rem', lineHeight: '1.7', color: '#333', display: 'flex', alignItems: 'flex-start' }}>
                        <i className="bi bi-heart-fill me-3" style={{ color: 'var(--tgh-blue-light)', fontSize: '1.2rem', marginTop: '2px', flexShrink: 0 }}></i>
                        <span>Partner with the hospital</span>
                      </li>
                      <li className="mb-3" style={{ fontSize: '1rem', lineHeight: '1.7', color: '#333', display: 'flex', alignItems: 'flex-start' }}>
                        <i className="bi bi-heart-fill me-3" style={{ color: 'var(--tgh-blue-light)', fontSize: '1.2rem', marginTop: '2px', flexShrink: 0 }}></i>
                        <span>Sponsor a ward or an equipment</span>
                      </li>
                      <li className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.7', color: '#333', display: 'flex', alignItems: 'flex-start' }}>
                        <i className="bi bi-heart-fill me-3" style={{ color: 'var(--tgh-blue-light)', fontSize: '1.2rem', marginTop: '2px', flexShrink: 0 }}></i>
                        <span>Volunteer your skills</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </ScrollSection>

          {/* Call to Action Section */}
          <ScrollSection>
            <div className="row mb-5">
              <div className="col-12">
                <div className="tgh-news-article text-center">
                  <h2 className="mb-4" style={{ fontSize: '2rem', fontWeight: '600', color: '#1a1a1a', fontFamily: "'Lora', 'Georgia', serif" }}>
                    Together, We Can Make a Difference
                  </h2>
                  <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#333', marginBottom: 0 }}>
                    Every contribution - big or small - directly strengthens healthcare delivery for families across
                    the region. Let's stand with Tema General Hospital.
                  </p>
                </div>
              </div>
            </div>
          </ScrollSection>

          {/* Contact Information Section */}
          <ScrollSection>
            <div className="row">
              <div className="col-12">
                <div className="tgh-news-card">
                  <div className="card-body p-4">
                    <div className="row">
                      <div className="col-md-6 mb-4 mb-md-0">
                        <h4 className="mb-3" style={{ fontSize: '1.3rem', fontWeight: '600', color: '#1a1a1a', fontFamily: "'Lora', 'Georgia', serif" }}>
                          Contact Us
                        </h4>
                        <p className="mb-2" style={{ fontSize: '1rem', color: '#333' }}>
                          <i className="bi bi-telephone-fill me-2" style={{ color: 'var(--tgh-blue-light)' }}></i>
                          <a href="tel:+233244872211" style={{ color: 'var(--tgh-blue-light)', textDecoration: 'none' }}>
                            +233 24 487 2211
                          </a>
                        </p>
                        <p className="mb-0" style={{ fontSize: '1rem', color: '#333' }}>
                          <i className="bi bi-telephone-fill me-2" style={{ color: 'var(--tgh-blue-light)' }}></i>
                          <a href="tel:+233303302696" style={{ color: 'var(--tgh-blue-light)', textDecoration: 'none' }}>
                            +233 30-330-2696/7
                          </a>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <h4 className="mb-3" style={{ fontSize: '1.3rem', fontWeight: '600', color: '#1a1a1a', fontFamily: "'Lora', 'Georgia', serif" }}>
                          Email
                        </h4>
                        <p className="mb-2" style={{ fontSize: '1rem', color: '#333' }}>
                          <i className="bi bi-envelope-fill me-2" style={{ color: 'var(--tgh-blue-light)' }}></i>
                          <a href="mailto:temageneral.ghgar@ghs.gov.gh" style={{ color: 'var(--tgh-blue-light)', textDecoration: 'none' }}>
                            temageneral.ghgar@ghs.gov.gh
                          </a>
                        </p>
                        <p className="mb-0" style={{ fontSize: '1rem', color: '#333' }}>
                          <i className="bi bi-envelope-fill me-2" style={{ color: 'var(--tgh-blue-light)' }}></i>
                          <a href="mailto:temageneralhospital2017@gmail.com" style={{ color: 'var(--tgh-blue-light)', textDecoration: 'none' }}>
                            temageneralhospital2017@gmail.com
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ScrollSection>
        </div>
      </section>
    </>
  );
}

export default SupportTGH;
